import { createSlice } from '@reduxjs/toolkit';

export const paymentSlice = createSlice({
  name: 'payment',
  initialState: {
    list: {},
    selected: null,
    order: []
  },
  reducers: {
    setList: (state, action) => {
      state.list = action.payload || {}
    },
    setOrder: (state, action) => {
      state.order  = action.payload || []
    },
    createUpdateItem: (state, { payload }) => {
      
      state.list = {
        ...state.list,
        ...payload
      }
    },
    setSelected: (state, action) => {
      state.selected = +action.payload
    },
    removeItem: (state, action) => {
      delete state.list[action.payload]
      state.selected = +Object.keys(state.list)[0]
    }
  }
})


export const { setList, createUpdateItem, setSelected, removeItem, setOrder } = paymentSlice.actions;

export default paymentSlice.reducer;